function setUser(user) {
  return {
    type: 'SET_USER',
    user,
  }
}

function setFileDetails(files) {
  return {
    type: 'SET_FILE_DETAILS',
    files,
  }
}

function setFileUploadProgress(file, progress) {
  return {
    type: 'SET_FILE_UPLOAD_PROGRESS',
    file,
    progress,
  }
}

function setTree(folderList) {
  return {
    type: 'SET_FOLDER_LIST',
    folderList,
  }
}

function setSharedUserList(sharedUserList) {
  return {
    type: 'SET_SHARED_USER_DETAILS',
    sharedUserList,
  }
}

function createFolder(folderName) {
  return { type: 'CREATE_FOLDER', folderName }
}

function setLimit(limit) {
  return { type: 'SET_LIMIT', limit }
}

function setPageNo(pageNo) {
  return { type: 'SET_PAGE_NUMBER', pageNo }
}

function setSortBy(sortBy) {
  return { type: 'SET_SORT_BY', sortBy }
}

function setSortType(sortType) {
  return { type: 'SET_SORT_TYPE', sortType }
}

function setStartDate(startDate) {
  return { type: 'SET_START_DATE', startDate }
}

function setEndDate(endDate) {
  return { type: 'SET_END_DATE', endDate }
}

function setBaseFolder(baseFolder) {
  return { type: 'SET_BASE_FOLDER', baseFolder }
}

function resetState() {
  return { type: 'SET_HEADER' }
}

function setFilesToUpload(filesToUpload) {
  return { type: 'SET_FILES_TO_UPLOAD', filesToUpload }
}

function setUserPermissionForFolder(userPermission) {
  return { type: 'SET_USER_PERMISSION_FOR_FOLDER', userPermission }
}

function setSharedFolderDetails(sharedFolderDetails) {
  return { type: 'SET_SHARED_FOLDER_DETAILS', sharedFolderDetails }
}

function setSharePath(shareePath) {
  return { type: 'SET_SHAREE_PATH', shareePath }
}

function setFileListFromResponse(fileList) {
  return {
    type: 'SET_FILE_LIST_FROM_RESPONSE',
    fileList,
  }
}

function setSelectedFolderToSearch(selectedFolderToSearch) {
  return { type: 'SET_SELECTED_FOLDER_TO_SEARCH', selectedFolderToSearch }
}

function setActiveMenu(activeMenu) {
  return { type: 'SET_ACTIVE_MENU', activeMenu }
}

export default {
  setUser,
  setFileDetails,
  setFileUploadProgress,
  setTree,
  setSharedUserList,
  createFolder,
  setLimit,
  setPageNo,
  setSortBy,
  setSortType,
  setStartDate,
  setEndDate,
  setBaseFolder,
  resetState,
  setFilesToUpload,
  setUserPermissionForFolder,
  setSharedFolderDetails,
  setSharePath,
  setFileListFromResponse,
  setSelectedFolderToSearch,
  setActiveMenu,
}
